import { motion } from "framer-motion";

const STATS = [
	{ value: "250+", label: "Schools partnered" },
	{ value: "1.2L+", label: "Admission enquiries generated" },
	{ value: "40+", label: "Cities across India" },
	{ value: "3.4x", label: "Average enquiry growth" },
];

export function Stats() {
	return (
		<section className="py-16 md:py-20">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
					{STATS.map((s, i) => (
						<motion.div key={s.label}
							initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
							transition={{ delay: i * 0.08 }}
							className="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-6 text-center"
						>
							<div className="font-heading text-3xl sm:text-4xl font-extrabold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">
								{s.value}
							</div>
							<p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{s.label}</p>
						</motion.div>
					))}
				</div>
			</div>
		</section>
	);
}
